// extracted by mini-css-extract-plugin
export default {"title":"IntakeHeader_title__RbLUv","description":"IntakeHeader_description__S1DjS"};